function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "141.5",
  cy: "166.8",
  r: "17.8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M141.7 49.8c34.5 0 63.3 8 83 23 9.3 7 16.9 16.2 21.9 26.8 5.5 11.6 8.4 26.2 8.4 41.8s-2.8 29.4-8.4 41c-5.1 10.5-12.6 19.7-21.9 26.8-19.7 15-48.5 23-83 23h-3l-3 .6-71.5 15.4v-36.4l-8.8-8.4c-17.9-17.1-26.9-38-26.9-62.1 0-15.6 2.8-30.2 8.4-41.8 5-10.5 12.5-19.7 21.9-26.7 19.7-15.1 48.5-23 82.9-23m0-28.5C63.5 21.3 0 59.2 0 141.3c0 35.9 15.5 63.3 35.7 82.6v59.5l106-22.9c78.2 0 141.7-37.1 141.7-119.3S219.9 21.3 141.7 21.3z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M127.3 77.8h28.5v64.3h-28.5z"
})));